import { render } from "./EventAutoMessageSettingView.vue?vue&type=template&id=89e0f8d8&scoped=true"
import script from "./EventAutoMessageSettingView.vue?vue&type=script&lang=js"
export * from "./EventAutoMessageSettingView.vue?vue&type=script&lang=js"

import "./EventAutoMessageSettingView.vue?vue&type=style&index=0&id=89e0f8d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e0f8d8"]])

export default __exports__